export enum ComponentMessage {
  NoData = 'No data to display',
  NoDataShort = '—',
  NoCompanyData = 'No data to display',
}
